import MainAccordion from 'components/Accordion/MainAccordion';
import { NoHypoData } from './NoHypoData';
import { HypoglycemiaList } from './HypoglycemiaList';
import { NumberHypoEventPart } from './NumberHypoEventPart';
import { HypoglycemiaReadings } from './HypoglycemiaReadings';

const deStructureHypoChart = (data) => {
  const destructureData = []
  destructureData.push( { hours: 'ساعت', allCount: 'رویداد های هایپو' })
  {data?.map((item, index) => {
    destructureData.push( {
      hours: `${item.from}-${item.to} `,
      allCount: item?.allCount,
      level2Count: item?.level2Count })

  })}
  return destructureData
};
const deStructureHypoList = (data) => {
  return {
    total: data.level1Count + data.level2Count,
    level1: data.level1Count,
    level2: data.level2Count,
    nocturnal: data.nocturnalCount,
  };
};
const HypoWrapper = ({ patientId,daysAgo ,hypoData}) => {
  const HypoglycemiaListData = hypoData ? deStructureHypoList(hypoData) : {};
  const HypoglycemiaChartData = hypoData ? deStructureHypoChart(hypoData.hourlies) : [];
  const emptyData =
      hypoData?.level1Count + hypoData?.level2Count + hypoData?.nocturnalCount === 0
      ? true
      : false;
  return (
    <MainAccordion
      open={'panel1'}
      header="تحلیل ریسک"
      subHeaderHypo={daysAgo}
    >
      {emptyData ? (
        <div style={{ marginBottom: '20px' }}>
          <NoHypoData />
        </div>
      ) : (
        <>
          <HypoglycemiaList HypoglycemiaListData={HypoglycemiaListData} patientId={patientId}/>
          <NumberHypoEventPart HypoglycemiaChartData={HypoglycemiaChartData} patientId={patientId}/>
          <HypoglycemiaReadings daysAgo={daysAgo} patientId={patientId}/>
        </>
      )}
    </MainAccordion>
  );
};

export default HypoWrapper;
